"use strict";var r=require("./constants-637363f6.js");var e=e=>{switch(e){case r.STATE.ENABLED:return"pointer";case r.STATE.DISABLED:return"not-allowed";case r.STATE.LOADING:return"progress";default:return"pointer"}};exports.getCursor=e;
